
import apiRequest from "../Component/customHool/axiosRequest";



const Payment = {
  async getAll(params) {
   
    return apiRequest('GET',`/payment/getAll`,{},params)
  },

  async Create(payload) {
    
    return apiRequest('POST',`/payment/create`,payload,{})
  },

  async getById(id) {
   
    return apiRequest('GET',`/payment/getById/${id}`,{},{})
  },

  async updateById(payload, id) {
   

    return apiRequest('PUT',`/payment/update/${id}`,payload,{})
  },

  async delete(id) {
   
    return apiRequest('DELETE',`/payment/delete/${id}`,{},{})
  },


  async acceptedByAdmin(id) {
  

    return apiRequest('PUT',`/payment/recievePayment/${id}`,{},{})
  },




};

export default Payment;
